import type { PostingIdentity } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { ListingProfileCard } from "./ListingProfileCard";

type ItemSellerCardProps = {
  postingIdentity?: PostingIdentity;
  ownerUserId?: string | number | null;
  ownerName?: string | null;
  isRent: boolean;
  sellerProfile: {
    name?: string | null;
    identityVerified?: boolean;
    verifiedProfessions?: readonly string[];
    city: string | null;
    province: string | null;
    memberSince: string | null;
    activeItemCount: number | null;
  } | null;
  rating?: { average: number; count: number } | null;
};

export function ItemSellerCard({ postingIdentity, ownerUserId, ownerName, isRent, sellerProfile, rating }: ItemSellerCardProps) {
  const { t } = useI18n();
  const sellerName = sellerProfile?.name || ownerName || t("detail.item.member");
  const sellerLocation = [sellerProfile?.city, sellerProfile?.province].filter(Boolean).join(", ");
  return <ListingProfileCard postingIdentity={postingIdentity} title={isRent ? t("detail.item.aboutOwner") : t("detail.item.aboutSeller")}
    profile={{ name: sellerName, role: t("detail.item.member"), location: sellerLocation, memberSince: sellerProfile?.memberSince, href: ownerUserId ? `/u/${ownerUserId}` : null, identityVerified: sellerProfile?.identityVerified, verifiedProfessions: sellerProfile?.verifiedProfessions }}
    statistics={[{ label: t("detail.item.listings"), value: sellerProfile?.activeItemCount }, { label: isRent ? t("detail.item.rentals") : t("detail.item.sold"), value: null }]}
    rating={rating || { average: null, count: 0 }} />;
}
